import { useTranslation } from 'react-i18next';
import { changeLanguage } from '@/i18n';
import { api } from '@/lib/api';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.language === 'ru' ? 'ru' : 'en';
  const pick = (lang: 'en' | 'ru') => {
    changeLanguage(lang);
    // язык писем и уведомлений — из профиля; без сессии (экран входа) запрос просто вернёт 401
    api.patch('/auth/me', { locale: lang }).catch(() => undefined);
  };

  return (
    <div
      className="flex items-center gap-0.5 rounded-full border border-background-200 bg-background-100 p-1"
      role="group"
      aria-label={t('lang.label')}
    >
      {(['en', 'ru'] as const).map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => pick(lang)}
          aria-pressed={current === lang}
          className={`cursor-pointer whitespace-nowrap rounded-full px-2 py-0.5 text-[10.5px] font-semibold uppercase tracking-[0.06em] transition-colors ${
            current === lang
              ? 'bg-background-50 text-foreground-950'
              : 'text-foreground-500 hover:text-foreground-800'
          }`}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}